import {
  ALTERNATIVE_LOCALES,
  AlternativeLocale,
  DEFAULT_LOCALE,
  Locale,
} from "./locales"

interface LocalizedRouteMap {
  [englishPath: string]: {
    [K in AlternativeLocale]: string
  }
}

// Naive route map
// rework this when scaling locales
// beyond German microsite
export const LOCALIZED_ROUTE_PATHS = [
  "/",
  "/catalog/",
  "/catalog/amazon-gift-cards/",
  "/demo/",
  "/demo/details/",
  "/demo/schedule/",
  "/demo/ty/",
  "/gift-card-api/",
  "/pricing/",
  "/products/ach-payments/",
  "/products/bulk-payouts/",
  "/products/fraud-prevention/",
  "/products/gift-cards/",
  "/products/overview/",
  "/products/visa-cards/",
  "/solutions/employee-incentives/",
  "/solutions/marketing-incentives/",
  "/solutions/research-incentives/",
]

export const localizedRoutes: LocalizedRouteMap =
  LOCALIZED_ROUTE_PATHS.reduce<LocalizedRouteMap>((acc, path) => {
    acc[path] = { de: "" }
    ALTERNATIVE_LOCALES.forEach(locale => {
      const localizedPath = `/${locale}${path}`
      acc[path][locale] = localizedPath
    })
    return acc
  }, {})

export function getLocalizedPagePath(
  pathname: string,
  locale: Nullable<Locale>,
): string | undefined {
  // no-op for English
  if (locale === DEFAULT_LOCALE) {
    return pathname
  }

  if (locale && localizedRoutes?.[pathname]?.[locale]) {
    return localizedRoutes[pathname][locale] as string
  }

  return undefined
}
